import { Component, Input, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { IBreadCrumb } from '../shared/models/breadcrumb.model';
import BreadcrumbService from '../shared/services/breadcrumb.service';
import { BreadcrumbComponent } from '../shared/components/breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-dashbaord',
    templateUrl: './user-profile.component.html',
    styleUrls: [
        '../../../../src/assets/css/ds-core.css',
        '../../../../src/assets/css/ds-button.css',
        '../../../../src/assets/css/ds-card.css',
        '../../../../src/assets/css/ds-form.css',
        '../../../../src/assets/css/ds-modal.css',
        '../../../../src/assets/css/ds-step-indicator.css',
        '../../../../src/assets/css/ds-tabs.css',
        '../../../../src/assets/css/ds-tile.css',
        './user-profile.component.css'
    ],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [BreadcrumbComponent, RouterOutlet]
})
export class UserProfileComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private breadcrumbService = inject(BreadcrumbService);
  private readonly ARM_WEB_COMPONENT_READY_KEY = 'armwebcomponent-ready';


  public breadcrumbsData: IBreadCrumb[];

  constructor() {
    this.router.initialNavigation();
    // This is to have the hosting application wait until the arm web component is ready before
    // navigating to the user profile page, otherwise, the arm web component router may not work 
    // and becomes unresponsive. This is set in UserProfileElementComponent and 
    // UserProfileComponent. - kevin.low 05/27/25
    sessionStorage.setItem(this.ARM_WEB_COMPONENT_READY_KEY, 'true');
    this.breadcrumbsData = this.breadcrumbService.buildBreadCrumb(this.activatedRoute.root);
  }

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd), 
      distinctUntilChanged()
    ).subscribe(() => {
      this.breadcrumbsData = this.breadcrumbService.buildBreadCrumb(this.activatedRoute.root);
    })
  }
}
